import React from 'react'
import PropTypes from 'prop-types'
import LogoutButton from './LogoutButton'

/**
 * A react component that is used to control the users login actions.
 * It provides a 'Login' button if the user is not logged in and a
 * 'Logout' button if they are logged in along side the users name
 */
const UserLogoutControl = (props) => (
	props.visible
		?
		<div className="UserLogoutControl">
			{React.Children.map(props.children, (child) => React.cloneElement(child, {click: props.click}))}
		</div>
		:
		null
)


UserLogoutControl.propTypes = {
	visible: PropTypes.bool.isRequired,
	/** The function to perform when the 'Logout' button is clicked */
	click: PropTypes.func.isRequired,
	/** The display component */
	children: PropTypes.element.isRequired
}

UserLogoutControl.defaultProps = {
	children: <LogoutButton text='Log Out'/>
}

export default UserLogoutControl  


// WEBPACK FOOTER //
// ./src/components/UserLogoutControl/UserLogoutControl.js